import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
// import SVG from 'react-inlinesvg';
import AdHocInvoiceModal from '../common/AdHocInvoiceModal/AdHocInvoiceModal';
// import chevronDown from '../../../assets/images/icons/chevronDown.svg';
import { deleteRequest } from '../../requestUtils';
import './ViewAdHocInvoiceDropdown.scss';
function ViewAdHocInvoiceDropdown(_ref) {
  var triggerText = _ref.triggerText,
    csrfToken = _ref.csrfToken,
    projectId = _ref.projectId,
    companyName = _ref.companyName,
    projectName = _ref.projectName,
    consultantFullName = _ref.consultantFullName,
    adHocInvoicesUrl = _ref.adHocInvoicesUrl,
    invoice = _ref.invoice;
  var handleDelete = function handleDelete() {
    return deleteRequest("".concat(adHocInvoicesUrl, "/").concat(invoice.resource_id), csrfToken).then(function () {
      window.location.reload();
    })["catch"](function () {});
  };
  return /*#__PURE__*/React.createElement(Dropdown, {
    className: "view-invoice-dropdown"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    className: "btn-dropdown-toggle",
    variant: "primary"
  }, triggerText), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    href: "#"
  }, /*#__PURE__*/React.createElement(AdHocInvoiceModal, {
    csrfToken: csrfToken,
    projectId: projectId,
    modalHeader: "Edit Ad-Hoc Invoice ID ".concat(invoice.id),
    triggerText: "Edit",
    formMode: "Edit",
    companyName: companyName,
    projectName: projectName,
    consultantFullName: consultantFullName,
    adHocInvoicesUrl: adHocInvoicesUrl,
    invoice: invoice,
    handleDelete: handleDelete
  })), /*#__PURE__*/React.createElement(Dropdown.Item, {
    href: "#"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-delete",
    onClick: handleDelete
  }, "Delete"))));
}
ViewAdHocInvoiceDropdown.propTypes = {
  triggerText: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  companyName: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
  consultantFullName: PropTypes.string.isRequired,
  adHocInvoicesUrl: PropTypes.string.isRequired,
  invoice: PropTypes.shape({}).isRequired
};
ViewAdHocInvoiceDropdown.defaultProps = {};
export default ViewAdHocInvoiceDropdown;